module.exports = __webpack_public_path__ + "img/enterprise-pp.36d58000.png";